var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionInTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_azioni_in_tabella",
    "data-name": "icona azioni in tabella",
    transform: "translate(-390 -14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "azioni_in_tabella",
    "data-name": "azioni in tabella",
    transform: "translate(-243.279 -369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_171",
    "data-name": "Tracciato 171",
    d: "M197.6.732a2.5,2.5,0,1,1-3.536,0,2.5,2.5,0,0,1,3.536,0",
    transform: "translate(447.945 383)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_172",
    "data-name": "Tracciato 172",
    d: "M197.6,194.066a2.5,2.5,0,1,1-3.536,0,2.5,2.5,0,0,1,3.536,0",
    transform: "translate(447.945 197.166)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_173",
    "data-name": "Tracciato 173",
    d: "M197.6,387.4a2.5,2.5,0,1,1-3.536,0,2.5,2.5,0,0,1,3.536,0",
    transform: "translate(447.945 11.334)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionInTable);
export default __webpack_public_path__ + "static/media/action_in_table.66f067031cc136ceabca39c0c52d632e.svg";
export { ForwardRef as ReactComponent };